import { createFileRoute } from "@tanstack/react-router";
import { MorePage } from "@/features/more/more-page";

export const Route = createFileRoute("/app/w/$weddingId/more")({ component: MorePage });
